import { render, staticRenderFns } from "./PinMessages.vue?vue&type=template&id=ef95afee&scoped=true"
import script from "./PinMessages.vue?vue&type=script&lang=js"
export * from "./PinMessages.vue?vue&type=script&lang=js"
import style0 from "./PinMessages.vue?vue&type=style&index=0&id=ef95afee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef95afee",
  null
  
)

export default component.exports